import React, { useEffect, useState } from "react";
import { FaUsers, FaCalendarAlt, FaUserTie, FaMosque } from "react-icons/fa";
import { getStatsOverview } from "../../utils/api";
import "./Statistics.css";

export default function Statistics() {
  const [stats, setStats] = useState({
    userCount: 0,
    eventCount: 0,
    panditCount: 0,
    mandirCount: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const data = await getStatsOverview();
        setStats({
          userCount: data.userCount || 0,
          eventCount: data.eventCount || 0,
          panditCount: data.panditCount || 0,
          mandirCount: data.mandirCount || 0,
        });
      } catch (err) {
        console.error("Failed to fetch stats:", err);
        setError("Failed to load statistics");
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  const statList = [
    { label: "Users", value: stats.userCount, icon: <FaUsers />, color: "#4CAF50" },
    { label: "Events", value: stats.eventCount, icon: <FaCalendarAlt />, color: "#2196F3" },
    { label: "Pandits", value: stats.panditCount, icon: <FaUserTie />, color: "#FF9800" },
    { label: "Mandirs", value: stats.mandirCount, icon: <FaMosque />, color: "#9C27B0" },
  ];

  // Calculate max value for graph scaling
  const maxValue = Math.max(...statList.map(s => s.value), 1);

  if (loading) {
    return (
      <div className="stats-loading">
        <div className="spinner"></div>
        <p>Loading statistics...</p>
      </div>
    );
  }

  if (error) {
    return <div className="stats-error">{error}</div>;
  }

  return (
    <div className="stats-container">
      <h2>Dashboard Overview</h2>
      <div className="stats-grid">
        {statList.map((stat) => (
          <div key={stat.label} className="stat-tile" style={{ borderColor: stat.color }}>
            <div className="stat-icon" style={{ color: stat.color }}>
              {stat.icon}
            </div>
            <div className="stat-content">
              <div className="stat-value">{stat.value}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
            {/* Graph bar */}
            <div className="stat-graph">
              <div 
                className="stat-bar" 
                style={{ 
                  height: `${(stat.value / maxValue) * 100}%`,
                  backgroundColor: stat.color 
                }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
